import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  chipWrapper: {
    display: 'inline-flex',
    gap: theme.spacing(0.5)
  },
  chipInfo: {
    marginRight: theme.spacing(1)
  }
}));

const ExtraInfoChips = ({ extraInfoChips }) => {
  const classes = useStyles();

  return (
    <div className={classes.chipWrapper}>
      {extraInfoChips &&
        extraInfoChips.length > 0 &&
        extraInfoChips.map((extraInfoChip, idx) => (
          <Chip
            className={classes.chipInfo}
            key={'extra-info-chip-' + idx}
            label={extraInfoChip.text}
            variant="outlined"
            size="small"
          />
        ))}
    </div>
  );
};

ExtraInfoChips.propTypes = {
  extraInfoChips: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      highlight: PropTypes.bool
    })
  )
};

export default ExtraInfoChips;
